import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const AddUser = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M19 8v3m0 0v3m0-3h-3m3 0h3m-8.5-4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M2.983 17.863C4.036 15.014 6.608 13 10 13s5.964 2.014 7.017 4.863c.41 1.105-.535 2.137-1.714 2.137H4.697c-1.179 0-2.123-1.032-1.715-2.137'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M10 2.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5'
          fill='currentColor'
        />
        <path
          d='M19.75 8a.75.75 0 1 0-1.5 0v2.25H16a.75.75 0 0 0 0 1.5h2.25V14a.75.75 0 0 0 1.5 0v-2.25H22a.75.75 0 1 0 0-1.5h-2.25z'
          fill='currentColor'
        />
        <path
          d='M10 12.25c-3.722 0-6.564 2.226-7.72 5.353a2.21 2.21 0 0 0 .39 2.225 2.65 2.65 0 0 0 2.027.922h10.606c.805 0 1.549-.352 2.027-.922a2.21 2.21 0 0 0 .391-2.225c-1.157-3.127-4-5.353-7.721-5.353'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
